import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5464_9787)">
      <path
        d="M24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12Z"
        fill="url(#paint0_linear_5464_9787)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.2848 11.7589L13.9153 13.1282V14.7594V15.865L16.2848 14.4957V11.7589ZM9.61712 8.42126L11.9866 9.7906L14.3561 8.42126L11.9866 7.05193L9.61712 8.42126ZM7.69024 13.1263V14.4957L8.33255 14.8648L10.0597 15.8631V13.1263L7.69024 11.7589V13.1282V13.1263ZM6.40567 15.2359V16.7201L5.76336 16.3491L5.12109 15.978V12.015V8.05209L11.9866 4.08911L18.8521 8.05209V15.9799L15.4184 17.9614L13.9135 18.8297V17.3454L17.5675 15.2359V9.53444L12.6289 12.3861C12.6289 13.1772 12.6289 13.9664 12.6289 14.7575V19.5718L11.9866 19.9429L11.3443 19.5718L8.5529 17.9614L7.69024 17.4641V15.9799L11.3443 18.0894V12.388L6.40567 9.53631V15.2378V15.2359ZM11.9866 11.2729L7.04797 8.42126L11.9866 5.56958L16.9252 8.42126L11.9866 11.2729Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_5464_9787"
        x1="20.7134"
        y1="21.0955"
        x2="-13.8535"
        y2="-21.7643"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#8F00FF" />
        <stop offset="0.531658" stop-color="#78A5EA" />
        <stop offset="1" stop-color="#00FFC2" />
      </linearGradient>
      <clipPath id="clip0_5464_9787">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
